/**
 * How a paper is told apart (bug fix 1, spec 8): "Paper N" within its subject, the student's
 * name beside it, the Ref on every printed page, and the time joined to the date.
 */
import type { PaperRow } from "../api/api";
import { chapterSpan } from "./chapters";

export const LENGTH_WORD: Record<PaperRow["length"], string> = {
  short: "Short",
  standard: "Standard",
  full: "Full",
};

/** "Paper 3"; plain "Paper" from a content that predates numbers (the deploys can race). */
export const paperLabel = (p: Pick<PaperRow, "number">) =>
  p.number ? `Paper ${p.number}` : "Paper";

/** "Chapter 21", "Chapters 1–3, 7". */
export function chaptersWord(numbers: number[]): string {
  return `${numbers.length === 1 ? "Chapter" : "Chapters"} ${chapterSpan(numbers)}`;
}

/** "Standard · Chapter 21". */
export const paperDetails = (p: Pick<PaperRow, "length" | "chapters">) =>
  `${LENGTH_WORD[p.length]} · ${chaptersWord(p.chapters)}`;

/** "Paper 3 · Standard · Chapter 21", or "Paper 3 · Mock before half term" with a name. */
export const paperTitle = (p: Pick<PaperRow, "number" | "name" | "length" | "chapters">) =>
  `${paperLabel(p)} · ${p.name ?? paperDetails(p)}`;

/** "18 Oct, 14:27", in the student's own time zone. */
export function madeAt(iso: string): string {
  const d = new Date(iso);
  const day = d.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${day}, ${time}`;
}

/** "18 October 2026, 14:27", for a printed cover. */
export function madeOn(iso: string): string {
  const d = new Date(iso);
  const day = d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${day}, ${time}`;
}
